import {Shape} from './index.js';

export class FreePolygon extends Shape {
	constructor({ points = [], fill = 'black', stroke = [1, 'black'] }) {
		super({ x: 0, y: 0, fill, stroke });
		this.points = points;
	}

	draw(context) {
		if (this.points.length < 3) return;
		context.save();
		context.beginPath();
		context.moveTo(this.points[0].x, this.points[0].y);
		this.points.forEach(point => context.lineTo(point.x, point.y));
		context.closePath();
		this.applyStyles(context);
		context.fill();
		context.stroke();
		this.beforeRestore(context)
		context.restore();
	}
}
